import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class TemplateService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/templates', query);
  }

  create(body: any) {
    return this.post('/v2/template', body);
  }

  find(id) {
    return this.get('/v2/template/' + id);
  }

  update(id, body) {
    return this.put('/v2/template/' + id, body);
  }

  _delete(id) {
    return this.delete('/v2/template/' + id);
  }

  deleteMany(body: any) {
    return this.post('/v2/template/deleteMany', body);
  }

  all(id) {
    return this.get('/v2/user/all-template/' + id);
  }

  getTicketTemplate(id) {
    return this.get('/v2/templates/user/' + id);
  }

  chatTemplate() {
    return this.get('/v2/chat/templates');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Template.service.ts